// Generated by purs version 0.13.8
"use strict";
var Data_Either = require("../Data.Either/index.js");
var Data_String_Regex = require("../Data.String.Regex/index.js");
var unsafeRegex = function (s) {
    return function (f) {
        return Data_Either.fromRight()(Data_String_Regex.regex(s)(f));
    };
};
module.exports = {
    unsafeRegex: unsafeRegex
};
